export default __webpack_public_path__ + "static/media/futureElon.5da3eefb.jpg";